import { CalendarDate } from "@internationalized/date";
import { STATUS_OPTIONS, TYPE_OPTIONS } from "../utils";
export const NA_TEXT = "N/A";
const STATUS_LABEL_MAP = new Map(STATUS_OPTIONS.map((o) => [o.value, o.label]));
const TYPE_LABEL_MAP = new Map(TYPE_OPTIONS.map((o) => [o.value, o.label]));
export const getStatusLabel = (status) => (status && STATUS_LABEL_MAP.get(status)) || NA_TEXT;
export const getTypeLabel = (type) => (type && TYPE_LABEL_MAP.get(type)) || NA_TEXT;
export const isEmpty = (value) => value === null || value === undefined || String(value).trim().length === 0;
export const withNA = (value) => isEmpty(value) ? NA_TEXT : String(value).trim();
export const formatDate = (dateStr) => {
    if (!dateStr)
        return NA_TEXT;
    const d = new Date(dateStr);
    if (isNaN(d.getTime()))
        return NA_TEXT;
    return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
};
export const toCalendarDate = (dateStr) => {
    if (!dateStr)
        return null;
    const parts = dateStr.split("T")[0].split("-").map(Number);
    if (parts.length === 3 && parts[0] && parts[1] && parts[2])
        return new CalendarDate(parts[0], parts[1], parts[2]);
    return null;
};
export const fromCalendarDate = (date) => {
    if (!date)
        return "";
    return `${date.year}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}`;
};
export const monthParam = (date) => {
    if (!date)
        return "";
    return `${date.year}-${String(date.month).padStart(2, "0")}`;
};
export const personName = (entity) => withNA(entity?.name);
